import { ErrorType } from '../../../types/core';
import { InvoiceValidationEntry } from '../../../types/invoices';
import { MONTHS } from '../../../utils/date';

export const getMonthName = (
  monthNumber: number,
  t: (key: string) => string,
): string => {
  if (monthNumber < 0 || monthNumber > 11) {
    throw new Error('Invalid month number. Must be between 0 and 11.');
  }
  return t(`months.${MONTHS[monthNumber]}`);
};

export const getValidationErrorMessage = (
  error: InvoiceValidationEntry,
  t: (stringId: string, content?: Record<string, string>) => string,
) => {
  if (error.type === ErrorType.InvoiceJourneysNotSubmitted) {
    return t(`invoice-validation.invoicejourneysnotsubmitted`, {
      COUNT_JOURNEYS: error.message,
    });
  } else return t(`invoice-validation.${error.type}`);
};
